
import React, { useState } from "react";
import { CardMedia, Box, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import noImage from "../../../../assets/noimage.jpg";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { 
  getResolvedPosterUrl, 
  getResolvedImageUrl, 
  getResolvedVideoUrl, 
  isBunnyStreamMedia 
} from "../../../../shared/mediaResolver";

const PostMediaViewer = ({ media = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const validMedia = media?.filter((item) => item?.fileUrl && item?.mediaType?.toUpperCase() !== "DOCUMENT");

  if (validMedia.length === 0) return null;
  const currentMedia = validMedia[currentIndex] || {};

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? validMedia.length - 1 : prev - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === validMedia.length - 1 ? 0 : prev + 1));
  };
  return (
    <Box position="relative" sx={{ height: 250, width: "100%", borderRadius: "8px", overflow: "hidden" }}>
      {currentMedia?.mediaType === "VIDEO" ? (
        <Box position="relative" sx={{ width: "100%", height: "100%" }}>
          {isBunnyStreamMedia(currentMedia) ? (
            <CardMedia
              component="img"
              height="250"
              image={getResolvedPosterUrl(currentMedia, noImage)}
              sx={{ objectFit: "cover", width: "100%", height: "100%", cursor: "pointer" }}
            />
          ) : (
            <video
              src={`${getResolvedVideoUrl(currentMedia)}#t=0.1`}
              poster={currentMedia?.thumbnailUrl || ""}
              style={{ objectFit: "cover", width: "100%", height: "100%", cursor: "pointer" }}
              preload="metadata"
            />
          )}

          {/* Play Icon Overlay */}
          <IconButton
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "rgba(0,0,0,0.55)",
              color: "white",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
              width: 50,
              height: 50,
              pointerEvents: "none",
            }}
          >
            <PlayArrowIcon fontSize="large" />
          </IconButton>
        </Box>
      ) : (
        <CardMedia
          component="img"
          height="250"
          image={getResolvedImageUrl(currentMedia, noImage)}
          alt="Post Media"
          sx={{ objectFit: "cover", cursor: "pointer" }}
        />
      )}

      {/* Navigation Buttons */}
      {validMedia?.length > 1 && (
        <>
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: 8,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(0,0,0,0.4)",
              color: "#fff",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
            }}
          >
            <ChevronLeft />
          </IconButton>

          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(0,0,0,0.4)",
              color: "#fff",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
            }}
          >
            <ChevronRight />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default PostMediaViewer;
